module.exports = __webpack_public_path__ + "img/9487c4a.png";